import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoajantaellorecab() {



    const cardData = {

keyword: "Pune to Ajanta Ellora Cab Service",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Ajanta Ellora Cab Service for tourists, families, history lovers, and group travelers planning a heritage trip to Aurangabad. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles with experienced long-route drivers for a smooth and hassle-free journey. Our service includes flexible one-way and round-trip options with 24/7 booking support, transparent pricing, and door-to-door pickup from Pune. Rising Cab Service ensures a relaxed and enjoyable travel experience while exploring Maharashtra’s UNESCO World Heritage caves.",

topPlaces: [
    {
        title: "Ajanta Caves",
        description:
            "Ajanta Caves are a UNESCO World Heritage Site famous for ancient Buddhist rock-cut caves dating back to the 2nd century BCE. The caves are known for their stunning murals, sculptures, and paintings that depict the life of Lord Buddha. Surrounded by a horseshoe-shaped cliff, Ajanta is a masterpiece of ancient Indian art and spirituality."
    },
    {
        title: "Ellora Caves",
        description:
            "Ellora Caves are one of the largest rock-cut monastery-temple cave complexes in the world, representing Hindu, Buddhist, and Jain traditions. The highlight is the Kailasa Temple, carved from a single rock, showcasing extraordinary ancient engineering and craftsmanship."
    },
    {
        title: "Kailasa Temple Ellora",
        description:
            "Kailasa Temple is the most remarkable structure in Ellora Caves, dedicated to Lord Shiva. It is carved entirely from a single rock and is considered one of the greatest architectural achievements in human history, attracting visitors from around the world."
    },
    {
        title: "Bibi Ka Maqbara",
        description:
            "Bibi Ka Maqbara is often called the 'Mini Taj Mahal' and was built in memory of Aurangzeb’s wife. Located in Aurangabad, it features Mughal-style architecture, beautiful gardens, and a white marble structure resembling the Taj Mahal."
    },
    {
        title: "Daulatabad Fort",
        description:
            "Daulatabad Fort is a powerful medieval fort known for its strong defense system, secret passages, and strategic location. It offers panoramic views of the surrounding region and showcases the military brilliance of ancient rulers."
    },
    {
        title: "Grishneshwar Jyotirlinga",
        description:
            "Grishneshwar Temple is one of the twelve Jyotirlingas dedicated to Lord Shiva and is located near Ellora Caves. It is a highly revered pilgrimage site with beautiful stone carvings and deep spiritual significance."
    },
    {
        title: "Aurangabad Caves",
        description:
            "Aurangabad Caves are ancient Buddhist rock-cut caves located on a hillside near the city. These caves are known for their intricate carvings, sculptures, and peaceful surroundings, making them a lesser-known but important attraction."
    },
    {
        title: "Panchakki",
        description:
            "Panchakki is a historical water mill built during the Mughal era, designed to generate energy using water from a distant spring. It is surrounded by gardens and reflects ancient engineering innovation."
    },
    {
        title: "Siddharth Garden and Zoo",
        description:
            "Siddharth Garden and Zoo is a popular family attraction in Aurangabad featuring a variety of animals, lush greenery, and recreational spaces. It is a relaxing stop for tourists visiting the city."
    },
    {
        title: "Soneri Mahal",
        description:
            "Soneri Mahal is a historic palace turned museum showcasing artifacts, sculptures, and exhibits from Maharashtra’s rich cultural history. It provides insight into the region’s royal and artistic heritage."
    }
],



services: [
    {
        name: "Pune to Grishneshwar Cab",
        description:
            "Rising Cab Service offers Pune to Grishneshwar Cab for devotees, families, and tourists visiting the sacred Grishneshwar Jyotirlinga near Ellora. Our comfortable AC cabs, experienced drivers, and flexible travel options ensure a smooth and safe pilgrimage journey with convenient pickup and drop services from Pune and nearby locations."
    },
    {
        name: "Pune to Ajanta Ellora Cab",
        description:
            "Book Pune to Ajanta Ellora Cab with Rising Cab Service for a complete sightseeing and heritage tour experience. Our service covers the world-famous Ajanta and Ellora Caves with professional drivers, well-maintained vehicles, and customizable travel itineraries for families, tourists, and group travelers."
    },
    {
        name: "Ajanta Ellora Taxi from Pune",
        description:
            "Rising Cab Service provides Ajanta Ellora Taxi from Pune for a comfortable and hassle-free long-distance journey. Explore ancient rock-cut caves, UNESCO heritage sites, and historical monuments with safe driving, AC comfort, and flexible sightseeing stops."
    },
    {
        name: "Pune to Ajanta Caves Cab",
        description:
            "Our Pune to Ajanta Caves Cab service offers reliable transportation for tourists and history lovers visiting the iconic Ajanta Caves. Enjoy a smooth ride with experienced drivers and well-planned travel schedules for a memorable heritage tour."
    },
    {
        name: "Pune to Ellora Caves Taxi Service",
        description:
            "Rising Cab Service provides Pune to Ellora Caves Taxi Service for comfortable travel to one of India’s most famous UNESCO heritage sites. Our cabs are ideal for families and groups looking for safe, affordable, and convenient sightseeing travel."
    },
    {
        name: "Ajanta Ellora Tour Package from Pune",
        description:
            "Book Ajanta Ellora Tour Package from Pune with Rising Cab Service for a complete cultural and historical journey. Our packages include sightseeing at Ajanta Caves, Ellora Caves, and nearby attractions with flexible travel plans and professional drivers."
    },
    {
        name: "Pune to Ajanta Ellora Cab Booking",
        description:
            "Rising Cab Service offers Pune to Ajanta Ellora Cab Booking with easy online and offline reservation options. We provide clean vehicles, experienced drivers, and customizable tour packages for a comfortable travel experience."
    },
    {
        name: "Pune to Ajanta Ellora Family Tour Cab",
        description:
            "Our Pune to Ajanta Ellora Family Tour Cab is perfect for families planning a cultural getaway. Enjoy spacious vehicles, safe driving, and personalized sightseeing plans covering Ajanta, Ellora, and surrounding attractions."
    },
    {
        name: "Luxury Cab Pune to Ajanta Ellora",
        description:
            "Rising Cab Service provides Luxury Cab Pune to Ajanta Ellora for premium travelers seeking comfort and elegance. Our luxury vehicles offer plush seating, smooth rides, and professional chauffeurs for a high-end travel experience."
    },
    {
        name: "Pune to Ajanta Ellora Tempo Traveller",
        description:
            "Book Pune to Ajanta Ellora Tempo Traveller with Rising Cab Service for group tours and family trips. Our spacious tempo travellers are ideal for long-distance travel with comfortable seating and experienced drivers."
    },
    {
        name: "Pune to Ajanta Ellora Sightseeing Cab",
        description:
            "Rising Cab Service offers Pune to Ajanta Ellora Sightseeing Cab for tourists who want a flexible and comfortable heritage tour. Explore caves, monuments, and scenic spots with well-planned travel itineraries."
    },
    {
        name: "Pune to Grishneshwar Cab Service",
        description:
            "Our Pune to Grishneshwar Cab Service provides safe and reliable transportation for temple visits. Visit the sacred Jyotirlinga with experienced drivers and comfortable AC vehicles for a peaceful pilgrimage experience."
    },
    {
        name: "Pune to Grishneshwar Taxi Service",
        description:
            "Rising Cab Service offers Pune to Grishneshwar Taxi Service with affordable pricing and professional drivers. Ideal for family and group temple visits with flexible pickup and drop options."
    },
    {
        name: "Pune to Grishneshwar Jyotirlinga Cab",
        description:
            "Book Pune to Grishneshwar Jyotirlinga Cab for a spiritual journey to one of Maharashtra’s most revered temples. We ensure a smooth and comfortable ride with experienced drivers and clean vehicles."
    },
    {
        name: "Grishneshwar Temple Cab from Pune",
        description:
            "Rising Cab Service provides Grishneshwar Temple Cab from Pune for devotees seeking a convenient pilgrimage experience with flexible travel schedules and safe transportation."
    },
    {
        name: "Pune to Grishneshwar Cab Booking",
        description:
            "Our Pune to Grishneshwar Cab Booking service allows easy reservation for temple travel with multiple vehicle options and affordable pricing for families and groups."
    },
    {
        name: "One Way Pune to Grishneshwar Cab",
        description:
            "Rising Cab Service offers One Way Pune to Grishneshwar Cab for budget-friendly and convenient travel without return booking requirements."
    },
    {
        name: "Round Trip Grishneshwar Taxi Pune",
        description:
            "Book Round Trip Grishneshwar Taxi Pune with Rising Cab Service for a complete pilgrimage journey with waiting time, comfortable vehicles, and experienced drivers."
    },
    {
        name: "Pune to Grishneshwar Darshan Cab",
        description:
            "Rising Cab Service provides Pune to Grishneshwar Darshan Cab for smooth and spiritual travel experience with priority temple visit arrangements."
    },
    {
        name: "Pune to Grishneshwar Innova Crysta",
        description:
            "Enjoy premium travel with Pune to Grishneshwar Innova Crysta from Rising Cab Service offering spacious seating, luxury comfort, and smooth highway travel."
    },
    {
        name: "Pune to Grishneshwar Tempo Traveller",
        description:
            "Book Pune to Grishneshwar Tempo Traveller for group pilgrimage tours with comfortable seating, AC facilities, and professional drivers."
    },
    {
        name: "Pune to Sambhajinagar taxi",
        description:
            "Rising Cab Service provides Pune to Sambhajinagar taxi for safe and affordable intercity travel with experienced drivers and flexible booking options."
    },
    {
        name: "Pune to Aurangabad taxi",
        description:
            "Our Pune to Aurangabad taxi service ensures comfortable long-distance travel with clean vehicles and reliable drivers for business and tourism trips."
    },
    {
        name: "Pune to Ajanta Ellora tour cab",
        description:
            "Rising Cab Service offers Pune to Ajanta Ellora tour cab for complete sightseeing experiences covering heritage caves, monuments, and tourist attractions."
    },
    {
        name: "Pune to Grishneshwar temple taxi",
        description:
            "Book Pune to Grishneshwar temple taxi for a smooth and spiritual journey with comfortable vehicles and professional drivers."
    },
    {
        name: "Aurangabad outstation cab Pune",
        description:
            "Rising Cab Service provides Aurangabad outstation cab Pune for reliable intercity travel with flexible pickup options and affordable pricing."
    },
    {
        name: "Pune to Sambhajinagar Innova Crysta",
        description:
            "Enjoy premium intercity travel with Pune to Sambhajinagar Innova Crysta offering luxury seating and smooth highway rides for families and groups."
    },
    {
        name: "Pune to Aurangabad Tempo Traveller",
        description:
            "Book Pune to Aurangabad Tempo Traveller with Rising Cab Service for group travel, corporate trips, and pilgrimage tours with comfortable seating and experienced drivers."
    }
],

tableData: [
    ["Pune to Grishneshwar Cab", "Pune to Ajanta Ellora Cab"],
    ["Ajanta Ellora Taxi from Pune", "Pune to Ajanta Caves Cab"],
    ["Pune to Ellora Caves Taxi Service", "Ajanta Ellora Tour Package from Pune"],
    ["Pune to Ajanta Ellora Cab Booking", "Pune to Ajanta Ellora Family Tour Cab"],
    ["Luxury Cab Pune to Ajanta Ellora", "Pune to Ajanta Ellora Tempo Traveller"],
    ["Pune to Ajanta Ellora Sightseeing Cab", "Pune to Grishneshwar Cab Service"],
    ["Pune to Grishneshwar Taxi Service", "Pune to Grishneshwar Jyotirlinga Cab"],
    ["Grishneshwar Temple Cab from Pune", "Pune to Grishneshwar Cab Booking"],
    ["One Way Pune to Grishneshwar Cab", "Round Trip Grishneshwar Taxi Pune"],
    ["Pune to Grishneshwar Darshan Cab", "Pune to Grishneshwar Innova Crysta"],
    ["Pune to Grishneshwar Tempo Traveller", "Pune to Sambhajinagar taxi"],
    ["Pune to Aurangabad taxi", "Pune to Ajanta Ellora tour cab"],
    ["Pune to Grishneshwar temple taxi", "Aurangabad outstation cab Pune"],
    ["Pune to Sambhajinagar Innova Crysta", "Pune to Aurangabad Tempo Traveller"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Ajanta Ellora Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable and dependable cab services from Pune to Ajanta and Ellora Caves for families, tourists, history enthusiasts, and group travelers."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Long-Distance Travel",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, and Tempo Travellers designed to deliver a relaxing journey throughout the trip."
    },
    {
        WhyChooseheading: "Visit UNESCO World Heritage Sites",
        WhyChoosedescription: "Explore the magnificent Ajanta and Ellora Caves, renowned worldwide for their ancient architecture, sculptures, paintings, and cultural significance."
    },
    {
        WhyChooseheading: "Customized Travel Packages Available",
        WhyChoosedescription: "Rising Cab Service offers flexible travel plans that can be tailored according to your sightseeing preferences, travel duration, and group requirements."
    },
    {
        WhyChooseheading: "Professional Drivers for Outstation Tours",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, route expertise, punctual travel schedules, and a pleasant touring experience."
    },
    {
        WhyChooseheading: "Affordable Ajanta Ellora Cab Packages",
        WhyChoosedescription: "We provide cost-effective Pune to Ajanta Ellora taxi services with transparent pricing and excellent value for every traveler."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Convenient pickup services are available from Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Viman Nagar, Pimpri Chinchwad, Pune Airport, and nearby locations."
    },
    {
        WhyChooseheading: "Ideal for Family Trips and Educational Tours",
        WhyChoosedescription: "Our Pune to Ajanta Ellora Cab Service is perfect for family vacations, student groups, heritage tours, photography enthusiasts, and cultural travelers."
    }
]
};

const faqData = [
    {
        question: "Do you provide Pune to Ajanta Ellora Cab Service?",
        answer: "Yes, Rising Cab Service offers dedicated cab services from Pune to Ajanta and Ellora Caves for sightseeing and tourism."
    },
    {
        question: "How far are Ajanta and Ellora Caves from Pune?",
        answer: "Ajanta Caves are approximately 430 km from Pune, while Ellora Caves are around 260 km from Pune depending on the route."
    },
    {
        question: "Which vehicles are available for the trip?",
        answer: "We provide Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and larger vehicles for group travel."
    },
    {
        question: "Can I book a multi-day Ajanta Ellora tour?",
        answer: "Yes, we offer both one-day and multi-day tour packages based on your travel preferences."
    },
    {
        question: "Do you provide one-way and round-trip services?",
        answer: "Yes, customers can choose one-way transfers or round-trip cab packages."
    },
    {
        question: "Are the drivers experienced for long-distance travel?",
        answer: "Yes, our drivers regularly operate Maharashtra tourism routes and have extensive experience in outstation travel."
    },
    {
        question: "Can families and senior citizens travel comfortably?",
        answer: "Yes, our vehicles are spacious, well-maintained, and suitable for families, children, and senior citizens."
    },
    {
        question: "Can I visit nearby attractions during the tour?",
        answer: "Yes, customized itineraries can include Daulatabad Fort, Bibi Ka Maqbara, Grishneshwar Temple, and other nearby attractions."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickup services are available from Pune Airport, Railway Station, hotels, homes, and major Pune locations."
    },
    {
        question: "How can I book a Pune to Ajanta Ellora Cab Service?",
        answer: "You can book your cab through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vivek Kulkarni",
        feedback:
            "Our Ajanta and Ellora tour was an unforgettable experience. The vehicle was comfortable, the driver was knowledgeable about the route, and the journey was smooth throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Pooja Jadhav",
        feedback:
            "We traveled with our family to Ajanta and Ellora and received excellent service from Rising Cab Service. The cab was clean, spacious, and perfectly suited for our long-distance trip.",
        rating: 5
    }
];















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Ajanta Ellora Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-ajanta-ellora-cab.jpg",
"description": "Book Pune to Ajanta Ellora Cab Service with Rising Cab Service for comfortable heritage tours, temple visits, and sightseeing trips. Travel to Ajanta Caves, Ellora Caves, and Grishneshwar Jyotirlinga with safe, affordable, and professional taxi service.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-ajanta-ellora-cab-service"
}
};





    return (
        <div>

<Helmet>
  <title>Pune to Ajanta Ellora Cab Service | Caves & Jyotirlinga Tour | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Ajanta Ellora Cab Service for heritage sightseeing and temple tours. Visit Ajanta Caves, Ellora Caves, and Grishneshwar Jyotirlinga with comfortable AC cabs and experienced drivers."
/>

<meta
 name="keywords"
 content="Pune to Grishneshwar Cab, Pune to Ajanta Ellora Cab, Ajanta Ellora Taxi from Pune, Pune to Ajanta Caves Cab, Pune to Ellora Caves Taxi Service, Ajanta Ellora Tour Package from Pune, Pune to Ajanta Ellora Cab Booking, Pune to Ajanta Ellora Family Tour Cab, Luxury Cab Pune to Ajanta Ellora, Pune to Ajanta Ellora Tempo Traveller, Pune to Ajanta Ellora Sightseeing Cab, Pune to Grishneshwar Cab Service, Pune to Grishneshwar Taxi Service, Pune to Grishneshwar Jyotirlinga Cab, Grishneshwar Temple Cab from Pune, Pune to Grishneshwar Cab Booking"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoajantaellorecab;